export function Star(): JSX.Element {
    return (
        <svg
            height={'12px'}
            focusable="false"
            className="rwlRatingStar"
            style={{ fill: '#FFB400' }}
            viewBox="0 0 576 512"
        >
            <path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z" />
        </svg>
    );
}

export function StarEmpty(): JSX.Element {
    return (
        <svg
            height={'12px'}
            focusable="false"
            className="rwlRatingStarEmpty"
            style={{ fill: '#DDD' }}
            viewBox="0 0 576 512"
        >
            <path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z" />
        </svg>
    );
}

export function StarHalf(): JSX.Element {
    return (
        <svg
            height={'12px'}
            focusable="false"
            className="rwlRatingStarHalf"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
        >
            <path
                fill={'#DDD'}
                d="M288.1 0c12.3 0 23.5 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3c-5.1 3.7-11.1 5.7-17.1 6l-3.2 0c-4.6-.2-9.2-1.5-13.5-3.7c-42.8-22.8-85.6-45.7-128.5-68.4c0-146.7 0-293.3 .1-439.9z"
            />
            <path
                fill="#FFB400"
                d="M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z"
            />
        </svg>
    );
}
